import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ManuscriptRouteGuard } from "~/pages/upload-manuscript/manuscript-route-guard";
import { UploadManuscript } from "~/pages/upload-manuscript/upload-manuscript";

export const Route = createFileRoute("/_app/manuscripts/")({
  head: () => ({
    meta: [{ title: i18n.t("general:documentTitle.manuscripts") }],
  }),
  component: ManuscriptsRoute,
});

function ManuscriptsRoute() {
  return (
    <ManuscriptRouteGuard allowTeaser>
      <UploadManuscript />
    </ManuscriptRouteGuard>
  );
}
